import React, {Fragment} from 'react';
import './loading.scss'
import BuyBeltError from './buy-belt-error';
function BuyBeltLoading({
    error=false
}) {
    if(error){
        return (
          <div id="buybelt-wrapper-new">
            <BuyBeltError/>
          </div>
        );
    }else{
        return (
            <div id="buybelt-wrapper-new">
                <div className="buybelt-loading-wrapper loading buybelt u__p-top--small">
                    <span className="u__bold buybelt-title">
                        How to Get It
                    </span>
                    <div className="loading__fulfillment-tiles card-deck">
                        <div className="card card-container card-background card-unselected card-disabled">
                            <div className="u__clearfix loading">
                                    <div className="buybelt__flex-wrapper">
                                        <div className="buybelt__box-loading no-justify-center store-box">
                                            <div className="loading__text_fat"></div>
                                            <div className="loading__text_normal"></div>
                                            <div className="loading__text_normal"></div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className="card card-container card-background card-unselected card-disabled">
                            <div className="u__clearfix loading">
                                    <div className="buybelt__flex-wrapper">
                                        <div className="buybelt__box-loading no-justify-center store-box">
                                            <div className="loading__text_fat"></div>
                                            <div className="loading__text_normal"></div>
                                            <div className="loading__text_normal"></div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className="card card-container card-background card-unselected card-disabled">
                            <div className="u__clearfix loading">
                                    <div className="buybelt__flex-wrapper">
                                        <div className="buybelt__box-loading no-justify-center store-box">
                                            <div className="loading__text_fat"></div>
                                            <div className="loading__text_normal"></div>
                                            <div className="loading__text_normal"></div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BuyBeltError/>
            </div>
          );

    }

}

export default BuyBeltLoading;
